import { render, staticRenderFns } from "./FormServicePlatform.vue?vue&type=template&id=49f2aaae&scoped=true&"
import script from "./FormServicePlatform.vue?vue&type=script&lang=js&"
export * from "./FormServicePlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f2aaae",
  null
  
)

export default component.exports